module.exports = __webpack_public_path__ + "202408221624/img/home_shop_avatar.096e72f7.jpg";